import { ApiService, NormalizeResponse, SERVICES } from '../../BaseService';

export const PricingService = {
    getCompositionDate: (productId: number) => {
        return NormalizeResponse(ApiService(SERVICES.WORK_PACKAGE_BUSINESS).get(`pricing/composition/date`));
    }
};
